import { render, staticRenderFns } from "./DetailsItem.vue?vue&type=template&id=06c1d1dc&scoped=true"
var script = {}
import style0 from "./DetailsItem.vue?vue&type=style&index=0&id=06c1d1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1d1dc",
  null
  
)

export default component.exports